import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import api from '../api/client';

function SeedsStatusPopup({ category, onClose }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    let endpoint = '/api/seeds_all_details';
    if (category === 'inStock') {
      endpoint = '/api/seeds_all_details?filter=stock';
    } else if (category === 'underTreatment') {
      endpoint = '/api/seeds_all_details?filter=treatment';
    } else if (category === 'underGermination') {
      endpoint = '/api/seeds_all_details?filter=germination';
    }

    api.get(endpoint)
      .then(response => response.data)
      .then(data => {
        // Filter data based on category to show only seeds with non-zero values
        const filteredData = data.filter(item => {
          if (category === 'inStock') return item.stock > 0;
          if (category === 'underTreatment') return item.treatment > 0;
          if (category === 'underGermination') return item.germination > 0;
          return true; // For 'all', show all seeds
        });
        setData(filteredData);
      })
      .catch(error => console.error('Error fetching details:', error));
  }, [category]);

  return (
    <div className="seeds-statuses-report-popup">
      <button className="seeds-statuses-report-close-btn" onClick={onClose}>
        <FontAwesomeIcon icon={faTimes} />
      </button>
      <h2>
        {category === 'inStock' ? 'Seeds in Stock' : 
         category === 'underTreatment' ? 'Seeds Under Treatment' : 
         category === 'underGermination' ? 'Seeds Under Germination' : 
         'Seed Details'}
      </h2>
      <table>
        <thead>
          <tr>
            <th>Seed Name</th>
            {category === 'inStock' && <th>Stock (lbs)</th>}
            {category === 'underTreatment' && <th>Treatment (lbs)</th>}
            {category === 'underGermination' && <th>Germination (lbs)</th>}
            {category === 'all' && (
              <>
                <th>Stock (lbs)</th>
                <th>Treatment (lbs)</th>
                <th>Germination (lbs)</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.seedName}</td>
              {category === 'inStock' && <td>{item.stock || 0}</td>}
              {category === 'underTreatment' && <td>{item.treatment || 0}</td>}
              {category === 'underGermination' && <td>{item.germination || 0}</td>}
              {category === 'all' && (
                <>
                  <td>{item.stock || 0}</td>
                  <td>{item.treatment || 0}</td>
                  <td>{item.germination || 0}</td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default SeedsStatusPopup;